<div class="tooltip-container" #tooltipRef (click)="openDialog($event)">
  <span class="tooltip-text" [innerHTML]="tooltipText"> </span>
</div>
